import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Collapse from '@material-ui/core/Collapse'
import {useStyles} from '../SideBarStyles.js'
import IconExpandLess from "@material-ui/icons/ExpandLess";
import IconExpandMore from "@material-ui/icons/ExpandMore";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import {useHistory} from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import React from "react";


function ManagementBookings(props) {

    const {DataStore} = props

    const classes = useStyles()
    const [open, setOpen] = React.useState(false)

    let history = useHistory();

    function handleClick() {
        setOpen(!open)
    }

    return (
        <List component="nav" className={classes.appMenu} disablePadding>
            <ListItem button onClick={handleClick} className={classes.menuItem}>
                <ListItemIcon className={classes.menuItemIcon}>
                    <AccessTimeIcon />
                </ListItemIcon>
                <ListItemText primary="Gestión de reservas" className={classes.menuItemText}/>
                {open ? <IconExpandLess className={classes.openSubMenuIcons}/> :
                    <IconExpandMore className={classes.openSubMenuIcons}/>}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Divider classes={{root: classes.divider}}/>
                <List>
                    <ListItem button className={classes.nested}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText  primary="Gestión de reservas" className={classes.subItemsText}
                                       onClick={() => {
                                           history.push("/control-panel/booking-management")
                                           DataStore.getTabs('Gestión de reservas')
                                       }}/>
                    </ListItem>
                </List>
                <Divider classes={{root: classes.divider}}/>
            </Collapse>
        </List>
    )
}

export default ManagementBookings